import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";

import { ListOdfs, findOdfs } from "../../_App/Redux/Slices/odfs/odfSlice";
import Loader from "../../_Layouts/Loader/Loader";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";

const ODFS = () => {
  const dispatch = useAppDispatch();
  const odfs = useAppSelector(ListOdfs);
  const [ShowModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState<any>(moment().startOf("month")); // Default to start of today
  const [endDate, setEndDate] = useState<any>(moment().endOf("month")); // Default to end of today

  const [searchTerm, setSearchTerm] = useState(""); // New state for search term
  const [loading, setLoading] = useState(true);

  // Filter odfs based on search term
  const filteredOdfs = odfs?.filter(
    (odf) =>
      odf?.odf_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      odf?.machine_code?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  useEffect(() => {
    dispatch(findOdfs({ startDate: startDate, endDate: endDate }));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Set loading to true before making API calls

        // Dispatch API calls
        await dispatch(findOdfs(null));

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);
  const [showModal, setShowModall] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleItemClick = (item: any) => {
    if (item.hasRestart) {
      setSelectedItem(item);
      setShowModall(true);
    } else {
      // Directly go to Curatif if no restart record
      window.location.href = `/curatifChecklists/${item.odf_code}/${item.machine_code}`;
    }
  };

  const handleConfirm = (isRestart: any) => {
    setShowModall(false);
    if (isRestart) {
      window.location.href = `/redemarageChecklists/${selectedItem?.odf_code}/${selectedItem?.machine_code}`;
    } else {
      window.location.href = `/curatifChecklists/${selectedItem?.odf_code}/${selectedItem?.machine_code}`;
    }
  };
  return (
    <div className="searchable-container">
      {loading ? (
        <Loader />
      ) : (
        <div className="row layout-top-spacing">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 filtered-list-search layout-spacing align-self-center mb-0 pb-2">
              <form className="form-inline my-2 my-lg-0">
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-search"
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                  <input
                    type="text"
                    className="form-control product-search"
                    id="input-search"
                    placeholder="Recherche ODFs, Machines..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </form>
            </div>
            <div
              className="col-3 pb-2"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label htmlFor="start-date"></label>
              <input
                className="date-input"
                type="date"
                id="start-date"
                value={startDate.format("YYYY-MM-DD")}
                onChange={(e) =>
                  setStartDate(moment(e.currentTarget.value, "YYYY-MM-DD"))
                }
              />
            </div>
            <div
              className="col-3 pb-2"
              style={{ display: "flex", alignItems: "center" }}
            >
              <label htmlFor="end-date"></label>
              <input
                className="date-input"
                type="date"
                id="end-date"
                value={endDate.format("YYYY-MM-DD")}
                onChange={(e) =>
                  setEndDate(moment(e.currentTarget.value, "YYYY-MM-DD"))
                }
              />
            </div>
          </div>
          <div className="searchable-items list">
            <div className="items items-header-section">
              <div className="item-content">
                <div className="col">
                  <h4>Libelle</h4>
                </div>
                <div className="user-email col">
                  <h4>Machine</h4>
                </div>
                <div className="user-email col">
                  <h4>Date</h4>
                </div>
              </div>
            </div>
            {filteredOdfs &&
              filteredOdfs.map((item: any, index: any) => (
                <div
                  className="items"
                  key={index}
                  style={{
                    background:
                      item.total_checklist === item.total_ko + item.total_ok
                        ? "#1abc9c"
                        : "white",
                  }}
                  onClick={() => handleItemClick(item)}
                >
                  <div
                    className="item-content"
                    style={{
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="user-profile col">
                      <div className="user-meta-info">
                        <p
                          className="user-name"
                          data-name="Alan Green"
                          style={{
                            color:
                              item.total_checklist ===
                              item.total_ko + item.total_ok
                                ? "#fff"
                                : "#3b3f5c",
                          }}
                        >
                          {item.odf_code}
                        </p>
                      </div>
                    </div>
                    <div className="user-profile col">
                      <div className="user-meta-info">
                        <p
                          className="user-name"
                          data-name="Alan Green"
                          style={{
                            color:
                              item.total_checklist ===
                              item.total_ko + item.total_ok
                                ? "#fff"
                                : "#3b3f5c",
                          }}
                        >
                          {item.machine_code}
                        </p>
                      </div>
                    </div>
                    <div className="user-email col">
                      <p
                        className="usr-email-addr"
                        data-email="alan@mail.com"
                        style={{
                          color:
                            item.total_checklist ===
                            item.total_ko + item.total_ok
                              ? "#fff"
                              : "#3b3f5c",
                        }}
                      >
                        {" "}
                        {item.date.toString().split("T")[0]}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      <Modal show={showModal} onHide={() => setShowModall(false)} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>ODF Restart Record</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          Choisir un checklist :
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleConfirm(false)}>
            Curatif
          </Button>
          <Button variant="primary" onClick={() => handleConfirm(true)}>
            Redémarrage
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ODFS;
